import { ActPaymentRequestModule } from './../components/act-payment-request/act-payment-request.module';
import { BrowserModule } from "@angular/platform-browser";
import { ErrorHandler, NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { IonicApp, IonicErrorHandler, IonicModule } from "ionic-angular";
import { AndroidFullScreen } from "@ionic-native/android-full-screen";
import { MyApp } from "./app.component";
import { StatusBar } from "@ionic-native/status-bar";
import { SplashScreen } from "@ionic-native/splash-screen";
import { UserServiceProvider } from "../providers/user-service/user-service";
import { ApiServiceProvider } from "../providers/api-service/api-service";
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { PosServiceProvider } from "../providers/pos-service/pos-service";
import { AnimalServiceProvider } from "../providers/animal-service/animal-service";
import { UtilGeneralProvider } from "../providers/util-general/util-general";
import { GeneralServiceProvider } from "../providers/general-service/general-service";
import { IonicSelectableModule } from "ionic-selectable";
import { ThemeableBrowser } from "@ionic-native/themeable-browser/ngx";
import { TextToSpeech } from "@ionic-native/text-to-speech";
import { cbProviderAlert } from "../providers/general-service/cbProviderAlert";
import { PrintProvider } from "../providers/print/print";
import { BluetoothSerial } from "@ionic-native/bluetooth-serial";
import { BarcodeScanner } from '@ionic-native/barcode-scanner';

import {
  BrowserAnimationsModule,
  NoopAnimationsModule
} from "@angular/platform-browser/animations";
import { ActServiceProvider } from "../providers/act-service/act-service";
import { CbPrintingProvider } from '../providers/cb-printing/cb-printing';

@NgModule({
  declarations: [MyApp],
  imports: [
    BrowserModule,
    IonicModule.forRoot(MyApp,{
      scrollPadding: false,
      scrollAssist: false,
      autoFocusAssist: false
      }),
    HttpClientModule,
    IonicSelectableModule,
    ActPaymentRequestModule,
  ],
  bootstrap: [IonicApp],
  entryComponents: [MyApp],

  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: ErrorHandler, useClass: IonicErrorHandler },
    ApiServiceProvider,
    UserServiceProvider,
    HttpClient,
    PosServiceProvider,
    AnimalServiceProvider,
    AndroidFullScreen,
    UtilGeneralProvider,
    GeneralServiceProvider,
    cbProviderAlert,
    ThemeableBrowser,
    TextToSpeech,
    BluetoothSerial,
    PrintProvider,
    BrowserAnimationsModule,
    NoopAnimationsModule,
    BarcodeScanner,
    ActServiceProvider,
    CbPrintingProvider,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts